import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import { useCalendarServiceOptions, useCalendarServiceStore } from '../../store';
import SubscriptionPanel from '../SubscriptionPanel';
import TeamSelector from '../TeamSelector';

import { useWindowSize } from '@hooks/useWindowSize';
import { useTranslateFn } from '@shared/Translate';

const Main = () => {
  const {
    options: { selectedTeamId: teamId, calendarContext, enableTitleTeamPage },
  } = useCalendarServiceOptions();
  const selectedTeams = useCalendarServiceStore((state) => state.selectedTeams);
  const setSelectedTeams = useCalendarServiceStore((state) => state.setSelectedTeams);

  const t = useTranslateFn();
  const { isMobile } = useWindowSize();

  const handleButtonClick = () => {
    setSelectedTeams([teamId]);
  };

  return (
    <div
      className={clsx(
        'pk-d--flex',
        'pk-justify-content--between',
        'pk-align-items--center',
        enableTitleTeamPage && 'pk-mb--m',
      )}
    >
      {enableTitleTeamPage && (
        <h2 className={clsx('pk-font-size--xl', 'pk-font-size-md--xl2', 'pk-font--comp-bold')}>{t('matches')}</h2>
      )}
      <div>
        {!teamId || calendarContext ? (
          <TeamSelector />
        ) : (
          <PkButton
            className={clsx(!enableTitleTeamPage && 'pk-mb--m')}
            appearance='outlined'
            width='auto'
            onPkClick={handleButtonClick}
          >
            {!isMobile && t('add_calendar')}
            <PkIcon className={clsx(!isMobile && 'pk-ml--xs')} name='actions-add-to-calendar' size={24} />
          </PkButton>
        )}
        {!!selectedTeams?.length && <SubscriptionPanel />}
      </div>
    </div>
  );
};

export default memo(Main);
